import React from 'react';
import {
  Clock,
  Scale,
  Timer,
  CalendarRange,
  Check,
  AlertCircle,
  Utensils,
  Info
} from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const NutricionBasica = ({ descripcion, necesidadesDiarias }) => {
  if (!necesidadesDiarias) return null;

  const { comidas } = necesidadesDiarias;

  return (
    <div className="space-y-4">
      {/* Alerta descriptiva */}
      <div className="bg-gradient-to-r from-orange-100 to-orange-50 rounded-lg p-3 border border-orange-200">
        <div className="flex items-start gap-2">
          <div className="p-1.5 bg-white rounded-lg">
            <Info className="h-5 w-5 text-orange-500" />
          </div>
          <p className="text-base sm:text-lg text-gray-700">
            {descripcion}
          </p>
        </div>
      </div>

      {/* Card de Necesidades Diarias */}
      <Card className="overflow-hidden bg-white">
        <CardHeader className="border-b bg-gradient-to-r from-orange-500/10 to-transparent p-4">
          <div className="flex items-center gap-2">
            <div className="p-2 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg shadow-sm">
              <Utensils className="h-5 w-5 text-white" />
            </div>
            <div>
              <CardTitle className="text-xl text-gray-800 font-semibold">
                Necesidades Diarias
              </CardTitle>
              <p className="text-base text-gray-500">
                Plan de alimentación recomendado
              </p>
            </div>
          </div>
        </CardHeader>

        <CardContent className="p-4 space-y-4">
          <div className="grid gap-4 sm:grid-cols-2">
            {/* Cantidades y Frecuencias */}
            <div className="bg-gradient-to-br from-orange-50 to-white rounded-lg p-3 border border-orange-100 hover:shadow-sm transition-all">
              <div className="flex items-center gap-2 mb-3">
                <div className="p-1.5 bg-white rounded-lg shadow-sm">
                  <Scale className="h-5 w-5 text-orange-500" />
                </div>
                <span className="text-lg font-medium text-gray-900">Cantidades Diarias</span>
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-white p-3 rounded-lg border border-orange-50 hover:border-orange-100 transition-all">
                  <div className="flex items-center gap-2 mb-1">
                    <Clock className="h-4 w-4 text-orange-500" />
                    <span className="text-base text-gray-700">Frecuencia</span>
                  </div>
                  <p className="text-lg font-medium text-gray-900">{comidas.frecuencia}</p>
                </div>

                <div className="bg-white p-3 rounded-lg border border-orange-50 hover:border-orange-100 transition-all">
                  <div className="flex items-center gap-2 mb-1">
                    <Scale className="h-4 w-4 text-orange-500" />
                    <span className="text-base text-gray-700">Cantidad</span>
                  </div>
                  <p className="text-lg font-medium text-gray-900">{comidas.cantidadDiaria}</p>
                </div>
              </div>
            </div>

            {/* Horarios */}
            <div className="bg-gradient-to-br from-orange-50 to-white rounded-lg p-3 border border-orange-100 hover:shadow-sm transition-all">
              <div className="flex items-center gap-2 mb-3">
                <div className="p-1.5 bg-white rounded-lg shadow-sm">
                  <CalendarRange className="h-5 w-5 text-orange-500" />
                </div>
                <span className="text-lg font-medium text-gray-900">Horarios Recomendados</span>
              </div>
              
              <div className="space-y-2">
                {comidas.horarios.map((horario, idx) => (
                  <div key={idx} 
                       className="flex items-center gap-2 bg-white p-2 rounded-lg border border-orange-50 hover:border-orange-100 transition-all">
                    <Timer className="h-4 w-4 text-orange-500" />
                    <span className="text-base text-gray-700">{horario}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Consejos */}
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-lg p-3 border border-orange-100">
            <div className="flex items-center gap-2 mb-3">
              <div className="p-1.5 bg-white rounded-lg shadow-sm">
                <AlertCircle className="h-5 w-5 text-orange-500" />
              </div>
              <span className="text-lg font-medium text-gray-900">Consejos Importantes</span>
            </div>
            <div className="grid gap-2">
              {comidas.consejos.map((consejo, idx) => (
                <div key={idx} 
                     className="flex items-start gap-2 bg-white p-2.5 rounded-lg border border-orange-50 hover:border-orange-100 transition-all">
                  <Check className="h-4 w-4 mt-1 text-orange-500" />
                  <span className="text-base text-gray-700">{consejo}</span>
                </div>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NutricionBasica;